/** Черновик чат-режима «Создать песню» (история чата, шаг, выбор, createdSong). */
export const CHAT_GENERATION_STATE_STORAGE_KEY = "chatGenerationState";
export function clearChatGenerationPersistedState() {
    try {
        localStorage.removeItem(CHAT_GENERATION_STATE_STORAGE_KEY);
    }
    catch {
        /* private mode */
    }
}
